import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'
import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'

export type LinkPropsType = MuiLinkProps & SpaceProps

const Link = styled(MuiLink)<LinkPropsType>`
  ${space}
`

export default Link
